import React from 'react';
import Icon from './Icon';

const SocialIcons = () => (
  <ul className="social-icons-container">
    <li>
      <a
        href="https://www.linkedin.com/company/crosscomm/"
        target="_blank"
        rel="noreferrer"
        aria-label="CrossComm on Linked In"
      >
        <Icon icon={['fab', 'linkedin-in']} size="lg" className="icon-color" />
      </a>
    </li>
    <li>
      <a
        href="https://twitter.com/CrossComm/"
        target="_blank"
        rel="noreferrer"
        aria-label="CrossComm on Twitter"
      >
        <Icon icon={['fab', 'twitter']} size="lg" className="icon-color" />
      </a>
    </li>
    <li>
      <a
        href="https://www.facebook.com/CrossComm/"
        target="_blank"
        rel="noreferrer"
        aria-label="CrossComm on Facebook"
      >
        <Icon icon={['fab', 'facebook-f']} size="lg" className="icon-color" />
      </a>
    </li>
  </ul>
);

export default SocialIcons;
